import './fontCss/video.css'
import {Component, createRef} from "react";
import RxPlayer from "rx-player/minimal";
import {getLiveKeySystems} from "../globalMethods/webservice";
import {DASH, DIRECTFILE, EME} from "rx-player/features";
import TimerFullScreen from "../globalMethods/timerFullScreen";
import SeekSlider from "./seekslider/slider";
import {valideLogin} from "../login/UserService";
import {isSafari} from "../globalMethods/utils";
import {getSavedBarcode} from "../globalMethods/myConfig";
RxPlayer.addFeatures([DASH, EME, DIRECTFILE]);

// ─────────────────────────────────────────────
//  Auto-recovery (same rules as the Android TV player)
// ─────────────────────────────────────────────
// Network errors (segment/manifest 503, timeout, offline) -> reload at the live edge
// instead of stopping. DRM / media errors are NOT retried (they would just loop).
const MAX_AUTO_RELOADS = 6;
const MAX_RELOAD_DELAY_MS = 5000;
// the reload counter is reset only after this much stable playback
const STABLE_PLAYBACK_RESET_MS = 20000;
const RETRYABLE_ERROR_TYPES = ["NETWORK_ERROR"];
const RETRYABLE_ERROR_CODES = ["PIPELINE_LOAD_ERROR", "PIPELINE_PARSE_ERROR", "MANIFEST_PARSE_ERROR"];

// More retries per request before RxPlayer gives up.
// RxPlayer v4 calls it requestConfig, v3 networkConfig.
const RX_MAJOR_VERSION = parseInt(String(RxPlayer.version || "4").split(".")[0], 10);
const REQUEST_RETRY_OPTIONS = RX_MAJOR_VERSION >= 4
    ? {
        requestConfig: {
            segment: {maxRetry: 8, timeout: 15000},
            manifest: {maxRetry: 8, timeout: 15000},
        },
    }
    : {
        networkConfig: {
            segmentRetry: 8,
            manifestRetry: 8,
            offlineRetry: Infinity,
        },
    };

export class RunnerPlayer extends Component {


    constructor(props) {
        super(props)
        this.state = {
            channels: [],
            paramsEpgId: props?.paramsEpgId,
            player: {},
            mpdUrl: props?.mpdUrl,
            userProfile: props?.userProfile,
            configuration: props?.config,
            programmStart:"09:30",
            programmEnd:"12:30",
            value:30,
            showVolume:false,
            events: props?.events,
            eventsProgress: 0,
            logoUrl:"",
            programmTitle:"",
            programmSubTitle:"",
            showBarMenu: true,
            counter: 0,
            cursor: "pointer",
            showDrawer: props?.showDrawer,
            setShowDrawer: props.setShowDrawer,
            channelLogo : props?.channelLogo,
            userCode : getSavedBarcode(),
            reconnecting: false,
            fatalError: null,
        }
        this.myVideoElementRef = createRef();
        this.player = null
        this.handleClose = props.handleClose;

        // auto-recovery bookkeeping
        this.loadOptions = null;
        this.reloadCount = 0;
        this.reloadTimer = null;
        this.stableTimer = null;
        this.unmounted = false;
    }

    componentWillUnmount() {
        this.unmounted = true;
        clearTimeout(this.reloadTimer);
        clearTimeout(this.stableTimer);
        // 3. Clean up: Dispose of the RxPlayer instance when the component unmounts
        // This prevents the error "The video element is already attached to another RxPlayer instance."
        if (this.player) {
            try {
                this.player?.dispose();
                this.player = null; // Clear the reference
            }
            catch (e) {
            }

        }
    }

    componentDidMount() {
        this.initPlayer()
    }

    // ─────────────────────────────────────────────
    //  Error handling / auto-reload
    // ─────────────────────────────────────────────
    isRecoverable(error) {
        if (!error) return false;
        return RETRYABLE_ERROR_TYPES.includes(error.type) || RETRYABLE_ERROR_CODES.includes(error.code);
    }

    handlePlayerError(err) {
        const error = (this.player && this.player.getError()) || err;
        console.error("❌ Player error:", error?.type, error?.code, error?.message);

        if (this.unmounted || !this.loadOptions) return;

        if (this.isRecoverable(error) && this.reloadCount < MAX_AUTO_RELOADS) {
            this.reloadCount += 1;
            const delay = Math.min(1000 * this.reloadCount, MAX_RELOAD_DELAY_MS);
            console.log(`🔄 Auto-reload ${this.reloadCount}/${MAX_AUTO_RELOADS} in ${delay} ms (${error?.code})`);
            this.setState({reconnecting: true, fatalError: null});
            clearTimeout(this.reloadTimer);
            this.reloadTimer = setTimeout(() => this.reloadPlayer(), delay);
            return;
        }

        // DRM / media error, or too many failures in a row -> show it
        this.setState({reconnecting: false, fatalError: error?.code || "PLAYBACK_ERROR"});
    }

    reloadPlayer() {
        if (this.unmounted || !this.player || !this.loadOptions) return;
        clearTimeout(this.stableTimer);
        try {
            // same RxPlayer instance (SeekSlider keeps its reference), fresh load at the live edge
            this.player.loadVideo(this.loadOptions);
        } catch (e) {
            console.error("Reload failed", e);
            this.handlePlayerError(e);
        }
    }

    manualRetry() {
        this.reloadCount = 0;
        this.setState({fatalError: null, reconnecting: true});
        this.reloadPlayer();
    }

    handlePlayerStateChange(state) {
        if (state === "PLAYING") {
            if (this.state.reconnecting) this.setState({reconnecting: false});
            // reset the counter only after stable playback (no endless reload loop)
            clearTimeout(this.stableTimer);
            this.stableTimer = setTimeout(() => {
                if (this.reloadCount > 0) console.log("✅ Playback stable again, reload counter reset");
                this.reloadCount = 0;
            }, STABLE_PLAYBACK_RESET_MS);
        } else if (state === "RELOADING" || state === "LOADING" || state === "STOPPED") {
            clearTimeout(this.stableTimer);
        }
    }

     async initPlayer() {

         const valide = await valideLogin()
         if (!valide) {
             window.location.href = "/"
         }
         const videoElement = document.getElementById("video")

         if (videoElement) {

             if (this.player) {
                 try {
                     if(this.player?.state?.includes("LOADING")){
                         this.player?.dispose();
                     }

                 }
                 catch (e) {
                 }

             }

             this.player = new RxPlayer({videoElement: videoElement})

             this.player?.setVolume(0.1)

             this.player.addEventListener("error", (err) => this.handlePlayerError(err))
             this.player.addEventListener("playerStateChange", (state) => this.handlePlayerStateChange(state))
             // retried request failures arrive as warnings — useful in the console
             this.player.addEventListener("warning", (w) => {
                 if (w?.code === "PIPELINE_LOAD_ERROR") console.warn("⚠️ Request failed, RxPlayer retries:", w?.message)
             })

             if (this.props.mpdUrl !== "") {

                 this.loadOptions = {
                     url: this.props.mpdUrl,
                     transport: !isSafari()? "dash" : "directfile",
                     autoPlay: true,
                     keySystems: getLiveKeySystems(this.props.paramsEpgId, this.props.userProfile, this.props.config),
                     referenceDateTime:
                         this.props.config.referenceDateTime || Date.UTC(2013, 5, 1, 0, 0, 0, 0) / 1000,
                     checkMediaSegmentIntegrity: undefined,
                     checkManifestIntegrity: undefined,
                     ...REQUEST_RETRY_OPTIONS,
                 }

                 this.player?.loadVideo(this.loadOptions)
             }


         }

     }

    render() {
        return (
            <>
                <TimerFullScreen hideControlBarAction={()=>{
                    this.setState({showBarMenu:false, cursor: "none"})
                    document.body.style.cursor = 'none';
                }}
                                 initialValue={()=> {
                                     this.setState({counter:0})
                                 }}
                                 isPlaying={this.state.player}
                                 counter={this.state.counter}
                                 isShowing={this.state.showBarMenu}
                                 handleClose={this.props.handleClose}
                                 setCounter={()=> {
                                     this.setState({counter:this.state.counter + 1})
                                 }}
                ></TimerFullScreen>




                <div
                     onMouseMove={()=>{
                         this.setState({showBarMenu:true, counter:0, cursor: "pointer"})
                         document.body.style.cursor = 'pointer';
                     }}
                     className='fullscreen-container' id="fullscreen-container">


                    <video ref={this.myVideoElementRef} id="video"></video>

                    {this.state.reconnecting && !this.state.fatalError && (
                        <div style={overlayStyle}>
                            <div style={overlayTextStyle}>Reconnecting…</div>
                        </div>
                    )}

                    {this.state.fatalError && (
                        <div style={overlayStyle}>
                            <div style={overlayTextStyle}>Playback failed ({this.state.fatalError})</div>
                            <button style={retryButtonStyle} onClick={() => this.manualRetry()}>
                                Retry
                            </button>
                        </div>
                    )}

                    <SeekSlider player={this.player}
                                showBarMenu={this.state.showBarMenu}
                                channelsInfo={this.state.events}
                                showTimerBarEvent={()=>{
                                    this.setState({showBarMenu:true, counter: 0})
                                }}
                                handleClose={this.handleClose}
                                chanelLogo={this.state.channelLogo}
                                userCode={this.state.userCode}
                    ></SeekSlider>

                </div>
            </>

        );
    }
}

const overlayStyle = {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(0,0,0,0.45)",
    zIndex: 5,
    pointerEvents: "auto",
}

const overlayTextStyle = {
    color: "#fff",
    fontSize: 18,
    fontFamily: "Orbitron, sans-serif",
}

const retryButtonStyle = {
    marginTop: 16,
    padding: "10px 28px",
    border: "none",
    borderRadius: 8,
    background: "#B8860B",
    color: "#fff",
    fontSize: 16,
    cursor: "pointer",
}